module.exports = __webpack_public_path__ + "3f16c813c5c1b5ebe4fb8f1e53eb57.otf";